module.exports = __webpack_public_path__ + "static/b1-4a909b40af424b41fe416c1c61ec198f.png";